import { FlexBox } from '@airship-platform/jam-web/components';
import Card, { CardProps } from '@mui/material/Card';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import { type PropsWithChildren } from 'react';

interface FollowUpChannelProps extends CardProps {
  title: string;
  subtitle: string;
  icon: React.ReactNode;
  action?: React.ReactNode;
}

const FollowUpChannelCard: React.FC<
  PropsWithChildren<FollowUpChannelProps>
> = ({ title, subtitle, icon, action, children, ...cardProps }) => (
  <Card variant={'bordered'} {...cardProps}>
    <FlexBox flexDirection={'column'} gap={2}>
      <FlexBox alignItems={'center'} gap={2}>
        <FlexBox
          alignItems={'center'}
          justifyContent={'center'}
          width={40}
          height={40}
          borderRadius={1.5}
          border={(theme) => `1px solid ${theme.palette.gray?.[300]}`}
          color={(theme) => theme.palette.gold?.[600]}
        >
          {icon}
        </FlexBox>

        <FlexBox flexDirection={'column'} flex={1} minWidth={0}>
          <Typography variant="body2">{title}</Typography>
          <Typography variant="body4" color={'text.secondary'}>
            {subtitle}
          </Typography>
        </FlexBox>

        {action}
      </FlexBox>

      {children && (
        <>
          <Divider />
          <FlexBox flexDirection={'column'} gap={2}>
            {children}
          </FlexBox>
        </>
      )}
    </FlexBox>
  </Card>
);

export default FollowUpChannelCard;
